var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHomepage = function SvgHomepage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.25 7.75C4.25 6.784 5.034 6 6 6h12c.966 0 1.75.784 1.75 1.75v7A1.75 1.75 0 0 1 18 16.5h-3.268q.018.123.018.25v1.5q0 .127-.018.25H16a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1 0-1.5h1.268a2 2 0 0 1-.018-.25v-1.5q0-.127.018-.25H6a1.75 1.75 0 0 1-1.75-1.75zM11 18.5h2a.25.25 0 0 0 .25-.25v-1.5a.25.25 0 0 0-.25-.25h-2a.25.25 0 0 0-.25.25v1.5c0 .138.112.25.25.25m7-3.5H6a.25.25 0 0 1-.25-.25v-7A.25.25 0 0 1 6 7.5h12a.25.25 0 0 1 .25.25v7A.25.25 0 0 1 18 15",
    clipRule: "evenodd"
  })));
};
export default SvgHomepage;